import _defineProperty from "@babel/runtime/helpers/defineProperty";
export var ORDER_UUID_STORAGE_KEY = 'active-order-uuid';
export var ORDER_SESSION_TOKEN_STORAGE_KEY = 'active-order-session-token';
export var ORDER_STORAGE_EXPIRY = 172800000; // 48 hours

export var ADD_ITEM_NOTIFICATION_NAME = 'add';
export var ADD_ITEM_NOTIFICATION_MESSAGE = 'Item added to cart';
export var CART_NOTIFICATION_MAP = _defineProperty({}, ADD_ITEM_NOTIFICATION_NAME, ADD_ITEM_NOTIFICATION_MESSAGE);